import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import AppView from 'areas/shell/components/AppView';
import CompetencySwipeList from 'areas/swipes/components/CompetencySwipeList';
import SingleActionButtonPanel from 'components/SingleActionButtonPanel';
import CompetenceSelectionDialog from 'areas/competence/components/CompetenceSelectionDialog';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import ScanningPage from 'areas/competence/components/ScanningPage';
import { scheduledCompetencies } from 'areas/competence/domain';
import AddEvidenceDialog from 'areas/competence/components/AddEvidenceDialog';
import { byQRCode, byLookup } from 'areas/cardLookup/actions';
import CardHolderView from 'areas/cards/components/CardHolderView';
import VisitorPassView from 'areas/visitorpass/components/VisitorPassView';
import { uploadSwipe } from 'areas/swipes/actions';
import SwipeEngine from 'areas/swipes/domain/swipeEngine';
import VisitorPassEngine from 'areas/visitorpass/domain/visitorPassEngine';
import alertActions from 'areas/alert/actions';
import CompetenceMonoIcon from 'components/Icons/Competency/CompetencyMono';
import { getCardCheckerCard, getCurrentCard } from 'areas/cards/selectors';
import { getCurrentVisitorPass } from 'areas/visitorpass/selectors';
import { activeSwipes } from 'areas/swipes/selectors';
// import { reactPlugin } from "../../appInsights";
// import { AppInsightsErrorBoundary } from "@microsoft/applicationinsights-react-js";

import {
    hideCardholderPage,
    hideVisitorPassPage
} from 'areas/cards/actions';

import {
    markPendingCompetenceAsComplete
} from 'areas/supervisor/actions';

import {
    openCompetenceSelectionScreen,
    closeCompetenceSelectionScreen,
    selectPendingCompetenceList,
    selectAvailableCompetenceList,
    chooseCompetence,
    openScanningPage,
    closeScanningPage,
    openAuthChooserDialog,
    closeAuthChooserDialog,
    openQRDialog,
    openQRScannerDialog,
    closeQRDialog,
    openManualLookupDialog,
    closeManualLookupDialog,
} from 'areas/competence/actions';

import visitorPassActions from 'areas/visitorpass/actions';
import displayMode from 'areas/swipes/domain/displayMode';
import styles from './styles';

class CompetenciesPage extends React.Component {

    state = {
        evidenceOpen: false,
        evidenceFile: null,
        evidenceSelected: false,
        denySwipeDialogOpen: false
    };

    swipeEngine = new SwipeEngine();

    visitorEngine = new VisitorPassEngine();

    awardCompetence = () => {
        const { card, pass, activeCompetence, currentLocation, cardCheckerCard, expiryDate } = this.props;

        let swipe = null;

        if (card) {
            const awardResult = this.swipeEngine.validateCompetence(card);

            if (awardResult.canAward) {
                swipe = this.swipeEngine.awardCompetence(card, currentLocation, cardCheckerCard, activeCompetence, expiryDate, this.state.evidenceFile);
            } else {
                swipe = this.swipeEngine.denyCompetence(card, currentLocation, cardCheckerCard, activeCompetence, awardResult);
            }
        } else {
            const awardResult = this.swipeEngine.validateVisitorPassCompetence(pass);
            if (awardResult.canAward) {
                swipe = this.swipeEngine.awardCompetenceToVisitorPass(pass, currentLocation, cardCheckerCard, activeCompetence, expiryDate, this.state.evidenceFile);
            } else {
                swipe = this.swipeEngine.denyCompetenceVisitorPass(pass, currentLocation, cardCheckerCard, activeCompetence, awardResult);
            }
        }

        this.props.uploadSwipe(swipe);

        this.props.closeCardholderView();
    };

    handleScan = (qrCode) => {
        this.props.closeQRDialog();

        setTimeout(() => {
            this.props.lookupQrCode(qrCode, this.props.currentLocation.site.siteCode)
        }, 100);
    };

    handleManualLookup = (formData) => {
        this.props.closeManualLookupDialog();
        const siteCode = this.props.currentLocation.site.siteCode;
        this.props.lookupPerson(
            formData.surname, formData.initial, (formData.dob ? formData.dob.toISODate() : ''), formData.cardNumber, siteCode);
    }

    handleVisitorPassScan = (qrCode) => {
        this.props.closeQRDialog();

        setTimeout(() => {
            this.props.alertMessage("Unable to award competencies to visitors");
        }, 100);
    };

    fabButtons() {
        return (
            <SingleActionButtonPanel
                actionText="Choose Competency"
                actionClicked={this.props.openCompetenceScreen}
                Icon={CompetenceMonoIcon}
                aboveBottomNavPanel={true}
            />
        );
    }

    competenceSelectionDialog() {
        const isOpen = Boolean(this.props.competenceChooserOpen);
        return (
            <CompetenceSelectionDialog
                open={isOpen}
                divisionData={this.props.divisionData}
                location={this.props.currentLocation}
                card={this.props.cardCheckerCard}
                handleClose={this.props.closeCompetenceScreen}
                handleSelection={this.props.chooseCompetence}
                scheduledSiteCompetencies={this.props.scheduledSiteCompetencies}
                handleCompetenceCompletion={this.props.markPendingCompetenceAsComplete}
                selectPendingTab={this.props.selectPendingCompetenceList}
                selectAvailableTab={this.props.selectAvailableCompetenceList}
                showPending={this.props.showPending} />
        );
    }

    openEvidenceDialog = () => {
        this.setState({
            evidenceOpen: true,
            handleEvidence: null
        });
    };

    closeEvidenceDialog = () => {
        this.setState({
            evidenceOpen: false,
            evidenceFile: null,
            evidenceSelected: false
        });
    };

    handleEvidence = (contents) => {
        this.setState({
            evidenceFile: contents,
            evidenceSelected: Boolean(contents),
            evidenceOpen: false
        });
    };

    handleFileError = (err) => {
        this.props.alertMessage(err);
    };

    onFileSelectionChanged = (file) => {
        this.setState({
            evidenceSelected: Boolean(file)
        });
    };

    evidenceDialog() {
        const isOpen = Boolean(this.state.evidenceOpen);

        return (
            <AddEvidenceDialog
                open={isOpen}
                config={this.props.config}
                handleClose={this.closeEvidenceDialog}
                handleApply={this.handleEvidence}
                handleFileError={this.handleFileError}
                onFileSelectionChanged={this.onFileSelectionChanged}
            />
        );
    }

    visitorPassView = () => {
        const { showVisitorPassPage, pass, config } = this.props;

        const isOpen = pass && showVisitorPassPage;
        const engineStatus = pass && this.visitorEngine.getVisitorPassStatus(pass);
        const canAward = pass && pass.isValid;
        const passToRender = pass ? pass.pass : null;

        const hasEvidence = Boolean(this.state.evidenceSelected);

        return (
            <VisitorPassView
                pass={passToRender}
                status={engineStatus}
                config={config}
                close={this.props.closeVisitorPassView}
                title="Visitor Pass"
                open={isOpen}>
                {canAward
                    ? [
                        <PrimaryDialogButton key="add" onClick={this.openEvidenceDialog}>
                            Add Evidence {hasEvidence ? ' (Attached)' : ''}
                        </PrimaryDialogButton>,
                        <PrimaryDialogButton key="ok" onClick={this.awardCompetence}>
                            OK
                        </PrimaryDialogButton>
                    ] : <PrimaryDialogButton onClick={this.awardCompetence}>OK</PrimaryDialogButton>
                }

            </VisitorPassView>
        );

    };

    cardHolderView = () => {
        const { showCardholderPage, card, config, currentLocation, viewContext } = this.props;
        const title = card ? `${card.firstname} ${card.surname}` : '';

        const validateAwardResult = showCardholderPage ? this.swipeEngine.validateCompetence(card) : null;
        const canAward = validateAwardResult && validateAwardResult.canAward;
        const denyReason = canAward ? null : { ...validateAwardResult };

        const hasEvidence = Boolean(this.state.evidenceSelected);

        return (
            <CardHolderView
                card={card}
                config={config}
                location={currentLocation}
                close={this.props.closeCardholderView}
                title={title}
                disableBackButton={false}
                viewcontext={viewContext}
                denyReason={denyReason}
                open={showCardholderPage}>
                {canAward
                    ? [
                        <PrimaryDialogButton key="evidence" onClick={this.openEvidenceDialog} color={hasEvidence ? 'secondary' : 'primary'}>
                            Add Evidence {hasEvidence ? ' (Attached)' : ''}
                        </PrimaryDialogButton>,
                        <PrimaryDialogButton key="award" onClick={this.awardCompetence}>Award</PrimaryDialogButton>
                    ]
                    : <PrimaryDialogButton onClick={this.awardCompetence}>OK</PrimaryDialogButton>
                }
            </CardHolderView>);
    };

    onScanError = (message) => {
        this.props.closeQRDialog();
        this.props.alert(message);
    };

    scanningPage() {
        return (
            <ScanningPage
                config={this.props.config}
                swipes={this.props.swipes}
                activeCompetence={this.props.activeCompetence}
                location={this.props.currentLocation}
                supervisorData={this.props.divisionData}
                handleManualLookup={this.handleManualLookup}
                open={this.props.scanningPageOpen}
                handleScan={this.handleScan}
                handleVisitorPassScan={this.handleVisitorPassScan}
                selectedCompetenceName={this.props.selectedCompetenceName}
                expiryDate={this.props.expiryDate}
                closeScanningPage={this.props.closeScanningPage}
                manualLookupDialogOpen={this.props.manualLookupDialogOpen}
                qrDialogOpen={this.props.qrDialogOpen}
                qrScannerOpen={this.props.qrScannerOpen}
                closeManualLookupDialog={this.props.closeManualLookupDialog}
                closeQRDialog={this.props.closeQRDialog}
                closeAuthChooserDialog={this.props.closeAuthChooserDialog}
                openAuthChooserDialog={this.props.openAuthChooserDialog}
                openManualLookupDialog={this.props.openManualLookupDialog}
                openQRDialog={this.props.openQRDialog}
                openQRScannerDialog={this.props.openQRScannerDialog}
                onScanError={this.onScanError}
            />
        );
    }

    competenceList() {
        const { swipes, classes, config, currentLocation, divisionData } = this.props;

        return (
            <div className={classes.listPanel}>
                <CompetencySwipeList
                    config={config}
                    location={currentLocation}
                    supervisorData={divisionData}
                    swipes={swipes || []} />
            </div>
        );
    }

    render() {
        const { showCardholderPage, scanningPageOpen, pageTitle } = this.props;
        return (
            <div>
                {/* <AppInsightsErrorBoundary onError={() => <h1>I believe something went wrong</h1>} appInsights={reactPlugin}> */}
                    <AppView title={pageTitle}>
                        {scanningPageOpen && !showCardholderPage && this.scanningPage()}
                        {!scanningPageOpen && this.competenceSelectionDialog()}
                        {showCardholderPage && this.evidenceDialog()}
                        {showCardholderPage && this.cardHolderView()}
                        {showCardholderPage && this.visitorPassView()}
                        {!scanningPageOpen && this.competenceList()}
                        {!scanningPageOpen && this.fabButtons()}
                    </AppView>
                {/* </AppInsightsErrorBoundary> */}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { alert, supervisor, competencies, location, config, cards } = state;
    const scheduledSiteCompetencies = scheduledCompetencies(supervisor, location);

    const { currentQrCode } = cards;

    const processedCard = getCurrentCard(state);
    const processedCardCheckerCard = getCardCheckerCard(state);
    const processedPass = getCurrentVisitorPass(state);

    const hasAlert = alert.message && alert.message.length > 0;

    return {
        config,
        currentQrCode: currentQrCode,
        swipes: activeSwipes(state),
        divisionData: supervisor,
        currentLocation: location,
        competencies: competencies,
        competenceChooserOpen: competencies.competenceChooserOpen,
        showPending: competencies.pendingListChosen,
        viewContext: competencies.pendingListChosen ? displayMode.awardPendingCompetence : displayMode.awardCompetence,
        scanningPageOpen: competencies.scanningPageOpen,
        scheduledSiteCompetencies,
        manualLookupDialogOpen: !hasAlert && competencies.manualLookupDialogOpen,
        qrDialogOpen: competencies.qrDialogOpen || false,
        qrScannerOpen: competencies.qrScannerDialogOpen || false,
        selectedCompetenceName: competencies.activeCompetence ? competencies.activeCompetence.name : '',
        activeCompetence: competencies.activeCompetence,
        expiryDate: competencies.expiryDate,
        cardConfig: cards,
        cards: cards.cards,
        card: processedCard,
        cardCheckerCard: processedCardCheckerCard,
        showCardholderPage: Boolean(cards.showCardholderPage),
        showVisitorPassPage: Boolean(cards.showVisitorPassPage),
        passes: cards.passes,
        pass: processedPass
    }
};

const mapDispatchToProps = dispatch => {
    return {
        alert: (message) => dispatch(alertActions.error(message)),
        openCompetenceScreen: () => dispatch(openCompetenceSelectionScreen()),
        closeCompetenceScreen: () => dispatch(closeCompetenceSelectionScreen()),
        selectPendingCompetenceList: () => dispatch(selectPendingCompetenceList()),
        selectAvailableCompetenceList: () => dispatch(selectAvailableCompetenceList()),
        chooseCompetence: (scheduledCompetence, expiryDate) => dispatch(chooseCompetence(scheduledCompetence, expiryDate)),
        openScanningPage: () => dispatch(openScanningPage()),
        closeScanningPage: () => dispatch(closeScanningPage()),
        markPendingCompetenceAsComplete: (competence) => dispatch(markPendingCompetenceAsComplete(competence)),
        closeAuthChooserDialog: () => dispatch(closeAuthChooserDialog()),
        openAuthChooserDialog: () => dispatch(openAuthChooserDialog()),
        openQRDialog: () => dispatch(openQRDialog()),
        openQRScannerDialog: () => dispatch(openQRScannerDialog()),
        closeQRDialog: () => dispatch(closeQRDialog()),
        openManualLookupDialog: () => dispatch(openManualLookupDialog()),
        closeManualLookupDialog: () => dispatch(closeManualLookupDialog()),
        lookupQrCode: (qrCode, siteCode) => dispatch(byQRCode(qrCode, null, false, siteCode)),
        lookupPerson: (surname, initial, dob, cardNumber, siteCode, context) => dispatch(byLookup(surname, initial, dob, cardNumber, context, false, siteCode)),
        lookupVisitorPass: (qrCode) => dispatch(visitorPassActions.byQRCode(qrCode)),
        closeCardholderView: () => dispatch(hideCardholderPage()),
        closeVisitorPassView: () => dispatch(hideVisitorPassPage()),
        uploadSwipe: (swipe) => dispatch(uploadSwipe(swipe)),
        alertMessage: (message) => dispatch(alertActions.warn(message)),
    };
};

const ConnectedPage = connect(mapStateToProps, mapDispatchToProps)(CompetenciesPage);

export default withStyles(styles)(ConnectedPage);